import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["answeredByPatientInput", "icon"];

  markAnsweredByProfessional() {
    this.answeredByPatientInputTarget.value = 0;
    this.iconTarget.classList.add("tw-hidden");
  }
}
